import { useScrollContext } from "../contexts/ScrollContextProvider";

export const useMenu = () => {
  const { isMenuClosed, setIsMenuClosed } = useScrollContext();

  const toggleMenu = () => {
    setIsMenuClosed(!isMenuClosed);
    console.log(`Menu is now ${isMenuClosed ? "open" : "closed"}`);
  };

  return { isMenuClosed, toggleMenu };
};
